<template>
  <div v-if="stepData.text_step">
    <DashboardAlert
      variant="danger"
      :title="stepData.text_step && stepData.text_step[0] && stepData.text_step[0].header"
      :description="stepData.text_step && stepData.text_step[0]&& stepData.text_step[0].description"
      :btn-text="stepData.text_step && stepData.text_step[0] && stepData.text_step[0].button_name"
      :btn-to="'/'+$i18n.locale+stepData.text_step[0].url"
      :btn-disabled="$route.path === '/'+$i18n.locale+stepData.text_step[0].url"
    />
    <!-- <div>
        <h3>{{ stepData.text_step && stepData.text_step[0] && stepData.text_step[0].header }}</h3>
        <div v-if=" stepData.text_step && stepData.text_step[0] && $route.path !== '/'+$i18n.locale+stepData.text_step[0].url">
          <hr>
          <p>
            {{ stepData.text_step && stepData.text_step[0]&& stepData.text_step[0].description }}
          </p>
          <b-button
            variant="success"
            :to="'/'+$i18n.locale+stepData.text_step[0].url"
          >
            {{ stepData.text_step && stepData.text_step[0] && stepData.text_step[0].button_name }}
          </b-button>
        </div>
      </div>
    </b-alert> -->
  </div>
</template>

<script>
import registerStep from '@/views/logics/components/registerSteps/registerStep'
import DashboardAlert from '../../dashboard/dashboardAlert.vue'

export default {
  components: {
    DashboardAlert,
  },
  mixins: [registerStep],
}
</script>
